import { render, staticRenderFns } from "./PrivilegeCriteria.vue?vue&type=template&id=9c37b8dc&"
import script from "./PrivilegeCriteria.vue?vue&type=script&lang=js&"
export * from "./PrivilegeCriteria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports